var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Container from '@telia-front/container';
import Grid, { GridColumn } from '@telia-front/grid';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
import List, { ListItem } from '@telia-front/list';
import Tag from '@telia-front/tag';
import { ThemeContext } from '@telia-front/theme-provider';
import HeaderMegamenuBanner from '../header-megamenu-banner/header-megamenu-banner';
class HeaderMegamenu extends React.PureComponent {
    constructor(props) {
        super(props);
        this.renderListTitle = (titleProps, titleId) => {
            const titleBEM = (hasTag) => {
                const classArray = ['h4 text-bold header__megamenu-title'];
                if (hasTag) {
                    classArray.push('header__megamenu-title--no-margin');
                }
                return classArray.join(' ');
            };
            const getTitle = (label, hasTag) => {
                return (React.createElement("div", { className: titleBEM(hasTag), id: titleId }, label));
            };
            if (typeof titleProps === 'string') {
                return getTitle(titleProps);
            }
            else if (titleProps.tag) {
                return (React.createElement(Grid, { verticalGutter: "none", horizontalGutter: "small" },
                    React.createElement(GridColumn, { width: ['xs', 'lg-12'] }, getTitle(titleProps.title, true)),
                    React.createElement(GridColumn, { width: ['xs', 'lg-12'] },
                        React.createElement(Tag, Object.assign({}, titleProps.tag, { className: "header__megamenu-title-tag" })))));
            }
            else {
                return getTitle(titleProps.title);
            }
        };
        this.renderList = (list, listIndex, columnId) => {
            const listId = list.id || listIndex;
            const titleId = this.generateTitleId(columnId, listId);
            // TODO: should have role="listitem" but html-validate does not allow it: https://gitlab.com/html-validate/html-validate/-/issues/102
            return (React.createElement("div", { className: "header__megamenu-section", key: listId },
                list.title && this.renderListTitle(list.title, titleId),
                React.createElement(List, { className: this.ListBEM(list), type: list.items.some(item => item.icon) ? 'icon' : 'unstyled', fullWidth: true, iconPosition: "middle", "aria-labelledby": list.title ? titleId : undefined }, this.renderListItems(list.items))));
        };
        this.handleResize = () => {
            var _a;
            const isMobile = window.matchMedia(`(max-width: ${this.context.media.width.md.max})`).matches;
            const refElementRect = (_a = this.props.reference) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            const container = this.props.id && document.getElementById(this.props.id);
            const containerRect = container && container.getBoundingClientRect();
            const containerLeft = containerRect && containerRect.left;
            const refElementLeft = refElementRect && containerLeft && refElementRect.left - containerLeft;
            const containerRight = containerRect && containerLeft && containerRect.right - containerLeft;
            if (typeof refElementLeft === 'number') {
                this.setState({
                    refElementLeft,
                });
            }
            if (typeof containerRight === 'number') {
                this.setState({
                    containerRight,
                });
            }
            if (this.state.isMounted && this.state.isMobile !== isMobile) {
                this.setState({
                    isMobile,
                });
            }
        };
        this.state = {
            refElementLeft: undefined,
            containerRight: undefined,
            isMobile: undefined,
            isMounted: false,
        };
    }
    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        const isMobile = window.matchMedia(`(max-width: ${this.context.media.width.md.max})`).matches;
        this.setState({
            isMounted: true,
            isMobile,
        });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    BEM() {
        const classArray = ['header__megamenu'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    linkBEM(item) {
        const classArray = ['header__megamenu-link'];
        if (item.isCurrent) {
            classArray.push('is-current');
        }
        if (item.color === 'employee') {
            classArray.push('header__megamenu-link--employee');
        }
        return classArray.join(' ');
    }
    renderListLink(item) {
        const { isExternal, isSecure, image, label, tag, icon, isCurrent } = item, rest = __rest(item, ["isExternal", "isSecure", "image", "label", "tag", "icon", "isCurrent"]);
        return (React.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: this.linkBEM(item), attributes: Object.assign(Object.assign({}, rest.attributes), { 'aria-current': isCurrent ? 'page' : undefined }) }),
            React.createElement("div", { className: "header__megamenu-link-inner" },
                React.createElement(Grid, { noWrap: true, gutter: "none" },
                    !!icon && (React.createElement(GridColumn, { width: ['min'] },
                        React.createElement(Icon, Object.assign({}, icon, { size: "xs", align: "middle", className: "header__nav-item-icon" })))),
                    React.createElement(GridColumn, { width: icon ? ['max'] : undefined },
                        label,
                        typeof isSecure !== 'undefined' && (React.createElement(Icon, { modifiers: isSecure ? '#lock' : '#lock-open', className: "header__megamenu-link-secure-icon", align: "middle" })),
                        isExternal && React.createElement(Icon, { modifiers: "#new-window", className: "header__megamenu-external-icon", align: "middle" })))),
            tag && React.createElement(Tag, Object.assign({}, tag, { size: "tiny", className: "header__megamenu-tag" })),
            image && React.createElement(Image, Object.assign({}, image, { className: "header__megamenu-link-image" }))));
    }
    renderListItems(items) {
        return items.map((item, index) => {
            return (React.createElement(ListItem, { key: item.id || index, className: "header__megamenu-list-item" }, this.renderListLink(item)));
        });
    }
    ListBEM(list) {
        const classArray = ['header__megamenu-list'];
        if (list.hasBorder) {
            classArray.push('header__megamenu-list--bordered');
        }
        return classArray.join(' ');
    }
    generateTitleId(columnId, listId) {
        if (this.props.id) {
            return `${this.props.id}-id-${columnId}-${listId}`;
        }
        return `header__megamenu-title-id-${columnId}-${listId}`;
    }
    columnBEM(column) {
        const classArray = ['header__megamenu-column'];
        if (column.hasBorder) {
            classArray.push('header__megamenu-column--bordered');
        }
        return classArray.join(' ');
    }
    renderColumns() {
        return this.props.columns.map((column, columnIndex) => {
            const columnId = column.id || columnIndex;
            return (React.createElement("div", { key: columnId, className: this.columnBEM(column) }, column.lists.map((list, listIndex) => {
                return this.renderList(list, listIndex, columnId);
            })));
        });
    }
    renderBanner(banner, count, index) {
        const width = count === 2 ? ['xs-12', 'lg-6'] : ['xs-12'];
        return (React.createElement(GridColumn, { width: width, key: index, className: "header__megamenu-banners-grid-col" },
            React.createElement(HeaderMegamenuBanner, Object.assign({}, banner))));
    }
    renderBannersGrid(banners) {
        return (React.createElement(Grid, { equalHeight: true, className: "header__megamenu-banners-grid" }, banners.map((item, index) => this.renderBanner(item, banners.length, index))));
    }
    renderBanners(banners) {
        return React.createElement("div", { className: "header__megamenu-banners" }, this.isBannerPropsArray(banners) ? this.renderBannersGrid(banners) : banners);
    }
    isBannerPropsArray(banners) {
        return Array.isArray(banners);
    }
    getMegamenuStyles() {
        var _a, _b;
        const refElementRect = (_a = this.props.reference) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const container = this.props.id && document.getElementById(this.props.id);
        const containerRect = container && container.getBoundingClientRect();
        const containerLeft = containerRect && containerRect.left;
        const refElementLeft = refElementRect && containerLeft && refElementRect.left - containerLeft;
        const refComputedStyle = this.props.reference && getComputedStyle(this.props.reference);
        const refElementLeftWithPadding = refElementLeft && refComputedStyle && refElementLeft + parseFloat(refComputedStyle.paddingLeft);
        const gridColumns = container && ((_b = container.firstElementChild) === null || _b === void 0 ? void 0 : _b.children);
        let gridColumnsWidth = 0;
        if (gridColumns) {
            gridColumnsWidth = Object.values(gridColumns).reduce((total, i) => total + i.offsetWidth, 0);
        }
        const distanceFromRefLeftToContainerRight = this.state.containerRight && this.state.refElementLeft && this.state.containerRight - this.state.refElementLeft;
        if (this.props.columns.length > 4) {
            return { width: '100%' };
        }
        else if (distanceFromRefLeftToContainerRight && distanceFromRefLeftToContainerRight < gridColumnsWidth) {
            return { width: '100%', justifyContent: 'flex-end' };
        }
        else if (refElementLeftWithPadding) {
            return {
                transform: `translate(${refElementLeftWithPadding}px, 0)`,
            };
        }
    }
    render() {
        const megamenu = (styles) => (React.createElement("div", { className: this.BEM(), id: this.props.id },
            React.createElement("div", { className: "header__megamenu-grid", style: styles }, this.renderColumns()),
            this.props.banners && this.renderBanners(this.props.banners)));
        if (!this.state.isMobile) {
            return React.createElement(Container, null, megamenu(this.getMegamenuStyles()));
        }
        else {
            return megamenu();
        }
    }
}
HeaderMegamenu.contextType = ThemeContext;
export default HeaderMegamenu;
